exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-7c9997a9]{margin:12px\n}\n.student-top-img[data-v-7c9997a9]{max-height:240px\n}", ""]);

// exports
